export const PartnerRegex = new RegExp(/^((\d{4}[.]{0,1}\d{4})|([-][0-9]{3}))+$/);
